<template>
  <div class="about">
    <ArtisanHeader />
    <ArtisanBody />
    <div class="my-5 pt-5">
      <ContactUsAction />
    </div>
    <ArtisanTuto />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import ArtisanHeader from "@/components/services/ArtisanHeader.vue";
import ArtisanBody from "@/components/services/ArtisanBody.vue";
import ArtisanTuto from "@/components/services/ArtisanTuto.vue";
import ContactUsAction from "@/components/partials/ContactUsAction.vue";

export default {
  name: "AboutView",
  components: {
    ArtisanHeader,
    ArtisanBody,
    ArtisanTuto,
    ContactUsAction,
  },
  mounted() {
    // Si tu utilises déjà ton observer global pour les animations :
    import("@/assets/globalJs/global.js").then(({ observeElements }) => {
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  setup() {
    useMeta({
      title: "Livraison sur chantier pour artisans du BTP – Livratos",
      description: [
        {
          content:
            "Avec Livratos, les artisans du BTP commandent leurs matériaux chez leurs fournisseurs habituels et se font livrer directement sur chantier par des livreurs professionnels.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/livraison-sur-chantier",
        },
      ],
    });
  },
};
</script>
